// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file services/project/resources/project_configuration/project_configuration.proto (package gx.project.resources.project_configuration, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file services/project/resources/project_configuration/project_configuration.proto.
 */
export const file_services_project_resources_project_configuration_project_configuration = /*@__PURE__*/
  fileDesc("CkxzZXJ2aWNlcy9wcm9qZWN0L3Jlc291cmNlcy9wcm9qZWN0X2NvbmZpZ3VyYXRpb24vcHJvamVjdF9jb25maWd1cmF0aW9uLnByb3RvEipneC5wcm9qZWN0LnJlc291cmNlcy5wcm9qZWN0X2NvbmZpZ3VyYXRpb24ihAIKFFByb2plY3RDb25maWd1cmF0aW9uEmAKFnByb2plY3RfbWFwcGluZ19tZXRob2QYASABKA4yQC5neC5wcm9qZWN0LnJlc291cmNlcy5wcm9qZWN0X2NvbmZpZ3VyYXRpb24uUHJvamVjdE1hcHBpbmdNZXRob2QSIwoWYXV0b19pbnRyb3NwZWN0X3Byb21wdBgCIAEoCUgAiAEBEikKHHByb2plY3Rfc3luY19jcm9uX2V4cHJlc3Npb24YAyABKAlIAYgBAUIZChdfYXV0b19pbnRyb3NwZWN0X3Byb21wdEIfCh1fcHJvamVjdF9zeW5jX2Nyb25fZXhwcmVzc2lvbiqiAQoUUHJvamVjdE1hcHBpbmdNZXRob2QSJgoiUFJPSkVDVF9NQVBQSU5HX01FVEhPRF9VTlNQRUNJRklFRBAAEh8KG1BST0pFQ1RfTUFQUElOR19NRVRIT0RfQVVUTxABEh8KG1BST0pFQ1RfTUFQUElOR19NRVRIT0RfSlNPThACEiAKHFBST0pFQ1RfTUFQUElOR19NRVRIT0RfQkxBTksQA0LxAgouY29tLmd4LnByb2plY3QucmVzb3VyY2VzLnByb2plY3RfY29uZmlndXJhdGlvbkIZUHJvamVjdENvbmZpZ3VyYXRpb25Qcm90b1ABWlxnaXRodWIuY29tL2dhbGF4eS1pby9neC9zaGFyZWQvZ28vY29udHJhY3RzL3NlcnZpY2VzL3Byb2plY3QvcmVzb3VyY2VzL3Byb2plY3RfY29uZmlndXJhdGlvbqICBEdQUlCqAilHeC5Qcm9qZWN0LlJlc291cmNlcy5Qcm9qZWN0Q29uZmlndXJhdGlvbsoCKUd4XFByb2plY3RcUmVzb3VyY2VzXFByb2plY3RDb25maWd1cmF0aW9u4gI1R3hcUHJvamVjdFxSZXNvdXJjZXNcUHJvamVjdENvbmZpZ3VyYXRpb25cR1BCTWV0YWRhdGHqAixHeDo6UHJvamVjdDo6UmVzb3VyY2VzOjpQcm9qZWN0Q29uZmlndXJhdGlvbmIGcHJvdG8z");

/**
 * Describes the message gx.project.resources.project_configuration.ProjectConfiguration.
 * Use `create(ProjectConfigurationSchema)` to create a new message.
 */
export const ProjectConfigurationSchema = /*@__PURE__*/
  messageDesc(file_services_project_resources_project_configuration_project_configuration, 0);

/**
 * Describes the enum gx.project.resources.project_configuration.ProjectMappingMethod.
 */
export const ProjectMappingMethodSchema = /*@__PURE__*/
  enumDesc(file_services_project_resources_project_configuration_project_configuration, 0);

/**
 * @generated from enum gx.project.resources.project_configuration.ProjectMappingMethod
 */
export const ProjectMappingMethod = /*@__PURE__*/
  tsEnum(ProjectMappingMethodSchema);

